import { createStore } from '@aibees/shared/store';
import { TransferListStoreData as StoreData } from './types';

const useTransferListStore = createStore<StoreData>(
  'transfer-list-analysis-store',
  (set) => ({
    config: undefined,
    setConfig: (config) => set({ config }),

    included: undefined,
    setIncluded: (included) => set({ included }),

    excluded: undefined,
    setExcluded: (excluded) => set({ excluded }),
  })
);

export default useTransferListStore;
